import { render, staticRenderFns } from "./CheckboxBlank.vue?vue&type=template&id=0f61fc55&"
import script from "./CheckboxBlank.vue?vue&type=script&lang=js&"
export * from "./CheckboxBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f61fc55')) {
      api.createRecord('0f61fc55', component.options)
    } else {
      api.reload('0f61fc55', component.options)
    }
    module.hot.accept("./CheckboxBlank.vue?vue&type=template&id=0f61fc55&", function () {
      api.rerender('0f61fc55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/CheckboxBlank.vue"
export default component.exports